import { Auth } from 'aws-amplify'
import { getAppDomain } from './runtime'

export const LAST_LOCATION = 'BUZZ_LAST_LOCATION'
export const TARGET_LOCATION = 'BUZZ_TARGET_LOCATION'

export const setLastLocation = (location: string, key?: string) =>
  localStorage.setItem(key || LAST_LOCATION, location)

export const getLastLocation = (key?: string) =>
  localStorage.getItem(key || LAST_LOCATION)

export const resetLastLocation = (key?: string) =>
  localStorage.removeItem(key || LAST_LOCATION)

/**
 * Helper function to get the appropriate auth headers based on the current domain
 * Returns authentication headers for API requests.
 */
export const getAuthHeaders = async () => {
  const { isPayReady } = getAppDomain()

  if (isPayReady) {
    return {
      headers: {
        'x-payready-flow': 'true',
      },
      withCredentials: true, //This is true as we DO want to send cookies in cross-origin requests
    }
  } else {
    try {
      const currentSession = await Auth.currentSession()
      const token = await currentSession.getAccessToken().getJwtToken()
      return {
        headers: { Authorization: token ? `Bearer ${token}` : '' },
        withCredentials: false, //This is fase, so that we DON'T send cookies in cross-origin requests
      }
    } catch (error) {
      console.error('Failed to get auth token:', error)
      throw error
    }
  }
}
